module.exports = __webpack_public_path__ + "img/B-761-770.0e152f6f.svg";